import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../helpers';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { NavService } from '../../../_services/NavService.service';

@Component({
  selector: 'app-order-management-summary',
  templateUrl: './order-management-summary.component.html',
  styleUrls: ['./order-management-summary.component.scss']
})
export class OrderManagementSummaryComponent implements OnInit, OnChanges {
  @Input() Type: any;
  @Input() isDetailsPageShow: boolean = false;
  @Input() title: string = 'Order Management Summary';

  @Output() refreshSummary = new EventEmitter<any>();
  @Output() dateFilterChange = new EventEmitter<any>();
  @Output() onActionClickOutput = new EventEmitter<any>();
  @Output() goToDetails = new EventEmitter<any>();
  @Output() onPageChangeEvent = new EventEmitter<any>();
  @Output() selectedRow = new EventEmitter<any>();

  activeTableDetails: ITableModel;
  activeStatusDetails: any[] = [];
  activeTitle: string = '';
  totalDataCount: number = 0;
  @Input() selectedFilter: string = 'Today';
  @Input() fromDate: string = '';
  @Input() toDate: string = '';
  dateFilterOptions: string[] = ['Today', 'Weekly', 'Monthly', 'Quarterly', 'Yearly', 'Custom'];

  private summaryConfigByType: any = {
    OutwardSummary: {
      title: 'Outward Summary',
      statusDetails: [
      { label: 'Total', dataFieldName: 'ALL', value: 0 },
      { label: 'Pick Pending', dataFieldName: 'PickPending', value: 0 },
      { label: 'Pack Pending', dataFieldName: 'PackPending', value: 0 },
      { label: 'Drop Pending', dataFieldName: 'DropPending', value: 0 },
      { label: 'Ready to Ship', dataFieldName: 'ReadyToShip', value: 0 },
      { label: 'Dispatched', dataFieldName: 'Dispatched', value: 0 },
      { label: 'In Transit', dataFieldName: 'InTransit', value: 0 },
      { label: 'Delivered', dataFieldName: 'Delivered', value: 0 }
    ],
      tableDetails: {
        data: [],
        columnDetails: [
          { columnName: 'Particulars', dataFieldName: 'Destination', alignType: 'left', width: '180px' },
          { columnName: 'Channel', dataFieldName: 'ChannelName', alignType: 'left', width: '120px' },
          { columnName: 'All', dataFieldName: 'ALL', alignType: 'right', width: '90px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Pick Pending', dataFieldName: 'PickPending', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Pack Pending', dataFieldName: 'PackPending', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Drop Pending', dataFieldName: 'DropPending', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Ready to Ship', dataFieldName: 'ReadyToShip', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Dispatched', dataFieldName: 'Dispatched', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'In Transit', dataFieldName: 'InTransit', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Delivered', dataFieldName: 'Delivered', alignType: 'right', width: '120px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          // { columnName: 'Undelivered', dataFieldName: 'Undelivered', alignType: 'center', width: '130px' }
        ],
        isColumnNameShow: true,
        isPagination: false,
        emptyDataMSg: 'No Outward Records Found'
      }
    },
    SalesOrderSummary: {
      title: 'Sales Order Summary',
      statusDetails: [
        { label: 'Total', dataFieldName: 'All', value: 0 },
        { label: 'Pending', dataFieldName: 'Pending', value: 0 },
        { label: 'Partial Pending', dataFieldName: 'PartialPending', value: 0 },
        { label: 'Allocated', dataFieldName: 'Allocated', value: 0 },
        { label: 'Cancel', dataFieldName: 'CancelQty', value: 0 }
      ],
      tableDetails: {
        data: [],
        columnDetails: [
          { columnName: 'Particulars', dataFieldName: 'Destination', alignType: 'left', width: '180px' },
          { columnName: 'Channel', dataFieldName: 'ChannelName', alignType: 'left', width: '120px' },
          { columnName: 'All', dataFieldName: 'All', alignType: 'right', width: '90px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Pending', dataFieldName: 'Pending', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Partial Pending', dataFieldName: 'PartialPending', alignType: 'right', width: '130px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Allocated', dataFieldName: 'Allocated', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
          { columnName: 'Cancel', dataFieldName: 'CancelQty', alignType: 'right', width: '110px',divType: "OrderSummaryCounts",CustPartnerId:"DestinationId" },
        ],
        isColumnNameShow: true,
        isPagination: false,
        emptyDataMSg: 'No Sales order Records Found'
      }
    }
  };
 
  DateFilter = {
    isRequired: false,
    formControlName: 'DateFilter',
    dataField: 'DateFilter',
    placeholder: 'Select here',
    isValueBind: true,
    dropdownList: [
      { value: "Today", name: "Today" },
      { value: "Weekly", name: "Weekly" },
      { value: "Monthly", name: "Monthly" },
      { value: "Quarterly", name: "Quarterly" },
      { value: "Yearly", name: "Yearly" },
      { value: "Custom", name: "Custom" }
    ]
  };

  OrderFromDate: any = {
    // lable: 'From Date',
    formControlName: 'OrderFromDate',
    dataField: 'OrderFromDate',
    type: "text",
    placeholder: 'Select here'
  };

  OrderToDate: any = {
    // lable: 'To Date',
    formControlName: 'OrderToDate',
    dataField: 'OrderToDate',
    type: "text",
    placeholder: 'Select here'
  };
  CompanyId: any;
  userId: any;

  ByCustomerOrDeliveryPartner = {
    isRequired: false,
    formControlName: 'ByCustomerOrDeliveryPartner',
    dataField: 'ByCustomerOrDeliveryPartner',
    placeholder: 'Select here',
    isValueBind: true,
    dropdownList: [
      { value: "Customer", name: "Customer" },
      { value: "DeliveryPartner", name: "DeliveryPartner" }
    ]
  };

  selectedFilterType = 'DeliveryPartner'
  @Output() emitDataToParent = new EventEmitter<any>(); //Added by fahim (१६ जुलै २०२६)
  @Output() emitOnlyDateFilterParent = new EventEmitter<any>(); //Added by fahim (१६ जुलै २०२६)
  @Input() changedFilterType: any;
  private hasSelectedFilterType = false;

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private _navService: NavService,
  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    // this.setDefaultToday();
    // this.setActiveTableDetails();
    // this.emitDateFilterChange();
    // this.GetOrderManagementSummary();
    // this.LoadEcommerceClient();
    if (!this.selectedFilter) {
      this.selectedFilter = 'Today';
    }
    // this.setRangeByFilter(this.selectedFilter);
    if (this.selectedFilter !== 'Custom') {
      this.setRangeByFilter(this.selectedFilter);
    }
    this.setActiveTableDetails();
    // this.GetOrderManagementSummary();

    this.LoadEcommerceClient();
    console.log('selectedFilterType on ngonint',this.selectedFilterType);
    
    setTimeout(() => {
      this._navService.navItem$.subscribe((item) => {
        if (
          this.CompanyId != JSON.parse(localStorage.getItem("ChnageCompnayId")).Id
        ) {
          this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
          this.LoadEcommerceClient();
        }
      });
    }, 500);
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.LoadEcommerceClient();
    let shouldReloadSummary = false;
    
    if (
      changes.changedFilterType &&
      changes.changedFilterType.currentValue !==
      changes.changedFilterType.previousValue
    ) {
      this.selectedFilterType = changes.changedFilterType.currentValue || 'DeliveryPartner';
      this.hasSelectedFilterType = true;
    }

    if (changes.Type) {
      this.setActiveTableDetails();
      shouldReloadSummary = true;
      // this.GetOrderManagementSummary();
    }

    if (
      changes.selectedFilter &&
      !changes.selectedFilter.firstChange &&
      changes.selectedFilter.currentValue
    ) {
      this.selectedFilter = changes.selectedFilter.currentValue;
      // this.setRangeByFilter(this.selectedFilter);
      if (this.selectedFilter !== 'Custom') {
        this.setRangeByFilter(this.selectedFilter);
      }
      shouldReloadSummary = true;
      // this.GetOrderManagementSummary();
    }

    if (
      changes.fromDate &&
      !changes.fromDate.firstChange &&
      changes.fromDate.currentValue !== changes.fromDate.previousValue
    ) {
      this.fromDate = changes.fromDate.currentValue;
      shouldReloadSummary = true;
    }

    if (
      changes.toDate &&
      !changes.toDate.firstChange &&
      changes.toDate.currentValue !== changes.toDate.previousValue
    ) {
      this.toDate = changes.toDate.currentValue;
      shouldReloadSummary = true;
    }

    if (shouldReloadSummary) {
      this.GetOrderManagementSummary();
    }

    console.log('selectedFilterType on ngOnChanges',this.selectedFilterType);
  }


  onFilterChange() {
    if (this.selectedFilter === 'Custom') {
      if (!this.fromDate) {
        this.fromDate = this.toInputDate(this.getToday());
      }
      if (!this.toDate) {
        this.toDate = this.toInputDate(this.getToday());
      }
    } else {
      this.setRangeByFilter(this.selectedFilter);
    }

    this.emitDateFilterChange();
  }

  onCustomDateChange() {
    this.emitDateFilterChange();
  }

  onRefreshClick() {
    this.refreshSummary.emit(this.getDateFilterPayload());
  }

  private setActiveTableDetails() {
    const config = this.getSummaryConfig();
    this.activeTitle = config.title || this.title;
    this.activeStatusDetails = config.statusDetails || [];
    this.activeTableDetails = config.tableDetails || this.getEmptyTableDetails();
    this.totalDataCount = this.activeTableDetails.data ? this.activeTableDetails.data.length : 0;
    this.updateStatusDetailsFromTableData();
  }

  private setDefaultToday() {
    this.selectedFilter = 'Today';
    this.setRangeByFilter(this.selectedFilter);
  }

  private setRangeByFilter(filterType: string) {
    const today = this.getToday();
    const startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (filterType === 'Weekly') {
      startDate.setDate(today.getDate() - 6);
    } else if (filterType === 'Monthly') {
      startDate.setMonth(today.getMonth() - 1);
    } else if (filterType === 'Quarterly') {
      startDate.setMonth(today.getMonth() - 3);
    } else if (filterType === 'Yearly') {
      startDate.setFullYear(today.getFullYear() - 1);
    }

    this.fromDate = this.toInputDate(filterType === 'Today' ? today : startDate);
    this.toDate = this.toInputDate(today);
  }

  private emitDateFilterChange() {
    this.GetOrderManagementSummary();
    this.dateFilterChange.emit(this.getDateFilterPayload());
  }

  private getDateFilterPayload(): any {
    return {
      Type: this.Type,
      filterType: this.selectedFilter,
      fromDate: this.toDisplayDate(this.fromDate),
      toDate: this.toDisplayDate(this.toDate)
    };
  }

  private getToday(): Date {
    return new Date();
  }

  private toInputDate(date: Date): string {
    const day = this.padDatePart(date.getDate());
    const month = this.getMonthName(date.getMonth());
    return day + '-' + month + '-' + date.getFullYear();
  }

  private toDisplayDate(dateValue: string): string {
    if (!dateValue) {
      return '';
    }

    const parts = dateValue.split('-');
    return parts.length === 3 && parts[0].length === 4 ? parts[2] + '-' + parts[1] + '-' + parts[0] : dateValue;
  }

  private getMonthName(monthIndex: number): string {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthNames[monthIndex];
  }

  private formatDateValue(value: any): string {
    if (!value) {
      return '';
    }

    if (value instanceof Date) {
      return this.toInputDate(value);
    }

    if (typeof value === 'string') {
      return this.toDisplayDate(value);
    }

    return value;
  }

  private padDatePart(value: number): string {
    return value < 10 ? '0' + value : String(value);
  }

  private getEmptyTableDetails(): ITableModel {
    return {
      data: [],
      columnDetails: [],
      isColumnNameShow: true,
      emptyDataMSg: 'No Records Found'
    };
  }

  private getSummaryConfig(): any {
    const typeKey = this.Type ? String(this.Type) : '';
    const summaryConfigKeys = Object.keys(this.summaryConfigByType);

    if (this.summaryConfigByType[typeKey]) {
      return this.summaryConfigByType[typeKey];
    }

    for (let i = 0; i < summaryConfigKeys.length; i++) {
      if (summaryConfigKeys[i].toLowerCase() === typeKey.toLowerCase()) {
        return this.summaryConfigByType[summaryConfigKeys[i]];
      }
    }

    return {
      title: this.title,
      statusDetails: [],
      tableDetails: this.getEmptyTableDetails()
    };
  }

  getChangedValue(value:any, data:any) {
    if(data.dataField === 'DateFilter'){
      this.selectedFilter = value && value.value ? value.value : value;
      this.setRangeByFilter(this.selectedFilter);
      this.emitDateFilterChange();
      // this.getDataFromTable(null);
      this.sendDateFilter();
    }else if(data.dataField === 'OrderFromDate'){
      this.fromDate = this.formatDateValue(value);
      this.emitDateFilterChange();
      this.sendDateFilter();
    }else if(data.dataField === 'OrderToDate'){
      this.toDate = this.formatDateValue(value);
      this.emitDateFilterChange(); 
      this.sendDateFilter();
    } else if(data.dataField === 'ByCustomerOrDeliveryPartner'){
      this.selectedFilterType = value;
      this.sendDateFilter();
      this.GetOrderManagementSummary();
    }
  }

  // private updateStatusDetailsFromTableData() {
  //   const tableData = this.activeTableDetails && this.activeTableDetails.data ? this.activeTableDetails.data : [];
  //   const columnDetails = this.activeTableDetails && this.activeTableDetails.columnDetails ? this.activeTableDetails.columnDetails : [];

  //   this.activeStatusDetails = this.activeStatusDetails.map((status) => {
  //     const dataFieldName = this.getStatusDataFieldName(status.label, columnDetails);

  //     return {
  //       ...status,
  //       value: dataFieldName ? this.sumTableDataByField(tableData, dataFieldName) : 0
  //     };
  //   });
  // }

  private updateStatusDetailsFromTableData() {
    const tableData =
      this.activeTableDetails &&
      Array.isArray(this.activeTableDetails.data)
        ? this.activeTableDetails.data
        : [];

    this.activeStatusDetails = this.activeStatusDetails.map((status) => {
      return {
        ...status,
        value: status.dataFieldName
          ? this.sumTableDataByField(tableData, status.dataFieldName)
          : 0
      };
    });
  }

  private sumTableDataByField(tableData: any[], fieldName: string): number {
    return tableData.reduce((total: number, row: any) => {
      const value = Number(row && row[fieldName] != null ? row[fieldName] : 0);

      return total + (isNaN(value) ? 0 : value);
    }, 0);
  }

  private getStatusDataFieldName(label: string, columnDetails: any[]): string {
    const compareLabel = label === 'Total' ? 'All' : label;

    for (let i = 0; i < columnDetails.length; i++) {
      if (columnDetails[i].columnName === compareLabel) {
        return columnDetails[i].dataFieldName;
      }
    }

    return '';
  }

  // private sumTableDataByField(tableData: any[], fieldName: string): number {
  //   let total = 0;

  //   for (let i = 0; i < tableData.length; i++) {
  //     total += Number(tableData[i][fieldName]) || 0;
  //   }

  //   return total;
  // }

  GetOrderManagementSummary(){
    const payload={
      CompanyId:this.CompanyId,
      FromDate:this.fromDate || null,
      ToDate:this.toDate || null,
      Type:this.Type,
      ByCustomerOrDeliveryPartner:this.selectedFilterType,
      UserId:this.userId
    }
    Helpers.setLoading(true);
    this._appService.Post('so_GoodsOutward','OrderManagementSummaryRept',payload).subscribe(
      (response)=>{
        Helpers.setLoading(false);
        if(response && response.length > 0){
          this.activeTableDetails.data = response;
        }
        
        this.activeTableDetails.data = response || [];
        this.totalDataCount = this.activeTableDetails.data.length;
        this.updateStatusDetailsFromTableData();
     
      },
      (err)=>{
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  // getDataFromTable(event:any){
  //   console.log('getDataFromTable',event);
  //   let obj:any={};
  //   if(this.selectedFilterType === 'Customer'){
  //     obj={
  //       DeliveryPartner:null,
  //       DeliveryPartnerName:null,
  //       CustomerId:event.CustPartnerId,
  //       CustomerName:event.row.Destination,
  //       FromDate:this.fromDate,
  //       ToDate:this.toDate,
  //       selectedDateFilter:this.selectedFilter,
  //       OutwardStatus:event.columnName
  //     }
  //   }else{
  //       obj={
  //       DeliveryPartner:event.CustPartnerId,
  //       DeliveryPartnerName:event.row.Destination,
  //       CustomerName:null,
  //       CustomerId:null,
  //       FromDate:this.fromDate,
  //       ToDate:this.toDate,
  //       selectedDateFilter:this.selectedFilter,
  //       OutwardStatus:event.columnName
  //     }
  //   }
  //   this.emitDataToParent.emit(obj);
  // }

  getDataFromTable(event: any) {
    console.log('getDataFromTable', event);

    const obj: any = {
      DeliveryPartner: null,
      DeliveryPartnerName: null,
      CustomerId: null,
      CustomerName: null,
      FromDate: this.fromDate || null,
      ToDate: this.toDate || null,
      selectedDateFilter: this.selectedFilter || null,
      OutwardStatus: event && event.columnName ? event.columnName : null,
      selectedFilterType: this.selectedFilterType || null,
      ChannelName: event && event.row && event.row.ChannelName ? event.row.ChannelName : null
    };

    if (this.selectedFilterType === 'Customer') {
      obj.CustomerId = event && event.CustPartnerId ? event.CustPartnerId : null;
      obj.CustomerName = event && event.row && event.row.Destination ? event.row.Destination : null;
    } else {
      obj.DeliveryPartner = event && event.CustPartnerId ? event.CustPartnerId : null;
      obj.DeliveryPartnerName = event && event.row && event.row.Destination ? event.row.Destination : null;
    }
    this.emitDataToParent.emit(obj);
  }

  // sendDateFilter(){
  //   this.emitOnlyDateFilterParent.emit(this.selectedFilter)
  // }

  sendDateFilter() {
    this.emitOnlyDateFilterParent.emit({
      selectedFilter: this.selectedFilter,
      fromDate: this.fromDate,
      toDate: this.toDate,
      selectedFilterType: this.selectedFilterType || null,
    });
  }

  isEcommerceClient: boolean = false;
  LoadEcommerceClient() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "so_e_commerce_client")
      .subscribe(
        (response) => {
          // if (response == "1") {
          //   this.isEcommerceClient = true;
          //   this.selectedFilterType = 'DeliveryPartner'
          // } else {
          //   this.isEcommerceClient = false;
          //   this.selectedFilterType = 'Customer'
          // }

          this.isEcommerceClient = response === '1';

          if (!this.hasSelectedFilterType) {
            this.selectedFilterType = this.isEcommerceClient ? 'DeliveryPartner' : 'Customer';
          }

          console.log("isEcommerceClient>>",this.isEcommerceClient);
          this.GetOrderManagementSummary();
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error",
          );
        },
      );
  }

}
